import { FC } from 'react';
import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import { operationTableFooterMap } from '../constants/operationTableFooterMap';

const OperationDetailsTableFooter: FC = () => {
  const { data } = useOperationDetailsPage();

  const OperationComponent =
    data.operation?.operationType &&
    operationTableFooterMap[data.operation?.operationType || ''];

  return (OperationComponent && <OperationComponent />) || null;
};

export default OperationDetailsTableFooter;
